class InfoTooltip extends HTMLElement {
  #boundSetup;
  #position = 'bottom';

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // State
    this.isVisible = false;
    this.#boundSetup = this.setup.bind(this);
    this.#position = this.getAttribute('position') || 'bottom';
  }

  connectedCallback() {
    this.render();

    if(window.requestAnimationFrame) {
      window.requestAnimationFrame(this.#boundSetup);
    } else {
      setTimeout(this.#boundSetup, 1);
    }
  }

  setup() {
    this.trigger = this.querySelector('[slot="trigger"]');
    this.tooltip = this.shadowRoot.querySelector('[part="tooltip-text"]');
    
    if (this.trigger) {
      this.setupAccessibility();
      this.setupEvents();
    }
  }

  setupAccessibility() {
    // Generate unique IDs
    const triggerId = this.trigger.id || `tooltip-trigger-${Math.random().toString(36).substr(2, 9)}`;
    const tooltipId = `tooltip-${Math.random().toString(36).substr(2, 9)}`;
    
    this.trigger.id = triggerId;
    this.tooltip.id = tooltipId;

    // add common classes
    this.trigger.classList.add('tooltip-trigger');
    
    // Set ARIA attributes
    this.trigger.ariaDescribedByElements = [this.tooltip];
    this.trigger.ariaControlsElements = [this.tooltip];
    this.trigger.setAttribute('type', 'button');
  }

  setupEvents() {
    // Bindings
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    // Hover & Focus Events
    this.trigger.addEventListener('mouseenter', this.show);
    this.trigger.addEventListener('mouseleave', this.hide);
    this.trigger.addEventListener('focus', this.show);
    this.trigger.addEventListener('blur', this.hide);

    // Keyboard Events
    this.trigger.addEventListener('keydown', this.handleKeyDown);
  }

  show() {
    if (this.isVisible) return;
    this.isVisible = true;
    this.tooltip.style.display = 'block';
    this.tooltip.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  hide() {
    if (!this.isVisible) return;
    this.isVisible = false;
    this.tooltip.style.display = 'none';
    this.tooltip.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline;
          height: auto;
          width: auto;
          line-height: 1;
        }

        :host::part(tooltip-text) {
          background-color: #fafafa;
          box-sizing: border-box;
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          margin: auto;
          max-width: 380px;
          padding: 15px;
          position: absolute;
          width: 92%;
          z-index: 1009;
          display: none;
          text-wrap: auto;
          left: 0;
          right: 0;
          ${this.#position === 'top' ? 'bottom: 0;' : ''}
        }
      </style>
      
      <slot name="trigger"></slot>
      <div
        part="tooltip-text"
        aria-hidden="true"
        aria-live="polite"
        role="tooltip"
      >
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('info-tooltip', InfoTooltip);